import { render, staticRenderFns } from "./TeachersList.vue?vue&type=template&id=68ec560f&"
import script from "./TeachersList.vue?vue&type=script&lang=js&"
export * from "./TeachersList.vue?vue&type=script&lang=js&"
import style0 from "./TeachersList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports